export const kPdfOnlyFileTypeMessage = 'PDF files only. Additional file types coming soon.'

// Shown when the viewable-url endpoint reports no viewable representation for the file
// (e.g. images). Retrying cannot succeed; the viewer's Download action serves the original.
// Also asserted by the e2e citation specs.
export const kUserFileUnsupportedPreviewMessage = "Preview isn't available for this file type. Download the original file to view it."
